import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';

const fieldsStyle = css`
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 0.875rem 1.375rem;
	margin: 0;

	@media (max-width: ${theme.layout.compactBreakpoint}) {
		grid-template-columns: minmax(0, 1fr);
	}
`;

const fieldStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
`;

const termStyle = css`
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.small};
	line-height: 1.55;
	color: ${theme.colors.inkMuted};
`;

const valueStyle = css`
	margin: 0;
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.medium};
	font-weight: ${theme.fontWeights.medium};
	line-height: 1.4;
	color: ${theme.colors.ink};
`;

export type SubjectFact = {
	readonly key: string;
	readonly label: string;
	readonly value: React.ReactNode;
};

type Props = {
	readonly facts: readonly SubjectFact[];
};

/** A dossier's facts as a definition list: one label and value pair per fact. */
const SubjectFactList: React.FC<Props> = ({ facts }) => {
	return (
		<dl css={fieldsStyle}>
			{facts.map((fact) => (
				<div key={fact.key} css={fieldStyle}>
					<dt css={termStyle}>{fact.label}</dt>
					<dd css={valueStyle}>{fact.value}</dd>
				</div>
			))}
		</dl>
	);
};

export default SubjectFactList;
